<template>
  <div class="hook-text u-pad-y-lg u-pad-y-md--sm u-center">
    <p class="u-pad-x-2of12 t-h3 t-italic" :class=" data.backgroundColored ? 'u-white' : 'u-blue' ">{{data.titre}}</p>
    <p v-if="data.description" class="t-text u-pad-x-2of12 u-pad-x-1of12--sm u-inline-block u-marg-t-md u-white-space" :class="data.backgroundColored ? 'u-white' : '' ">
      {{data.description}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'HookText',
   props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>